export const BELT_COLORS = {
  white: "#E4E4E7",
  blue: "#2563EB",
  purple: "#7C3AED",
  brown: "#7C4A21",
  black: "#18181B",
};

export function BeltBar({ belt = "white", stripes = 0, className = "w-20 h-4" }) {
  const barColor = belt === "black" ? "#E50914" : "#0A0A0A";
  return (
    <div
      data-testid="belt-bar"
      className={`relative rounded-[3px] flex justify-end overflow-hidden border border-white/10 ${className}`}
      style={{ background: BELT_COLORS[belt] }}
    >
      <div className="h-full w-[38%] mr-[10%] flex items-stretch justify-start gap-[3px] px-[3px] py-0" style={{ background: barColor }}>
        {Array.from({ length: stripes }).map((_, i) => (
          <span key={i} className="w-[3px] bg-white" />
        ))}
      </div>
    </div>
  );
}

export function BeltLabel({ belt, stripes }) {
  return (
    <span className="text-sm text-[#A1A1AA] capitalize">
      {belt} belt{stripes ? ` · ${stripes} stripe${stripes > 1 ? "s" : ""}` : ""}
    </span>
  );
}
